import React, {useState, useEffect, forwardRef, useImperativeHandle} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Modal, Pagination, Checkbox, message} from 'antd';
import {getTags} from '@/api/customer';
import styles from './tag.modal.module.less';
import {listCustomerTagLink, saveCustomerTagLink} from '@/api/customer';

const TagModal = forwardRef(({reload}, ref) => {
    useImperativeHandle(ref, () => ({
        open,
    }));
    const [visible, setVisible] = useState(false);
    const [current, setCurrent] = useState(1);
    const [size, setSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [tagGroups, setTagGroups] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    // 保存原始的查询到的已经保存的taglink
    const [orginalTags, setOrginalTags] = useState([]);
    const [followId, setFollowId] = useState(null);
    useEffect(() => {
        init();
    }, [current]);

    function init() {
        let initParams = {
            current: current,
            size: size,
        };
        getTags(initParams).then(res => {
            console.log(res);
            const {
                data: {current, size, total, records},
            } = res;
            console.log(current, size, total, records);
            setCurrent(current);
            setTotal(total);
            setTagGroups(records);
        });
    }

    function open(id) {
        setVisible(true);
        listCustomerTagLink(id).then(res => {
            if (res.data.length > 0) {
                setOrginalTags(res.data);
                let temp = res.data.map(item => item.tagId);
                setSelectedTags(temp);
            } else {
                setSelectedTags([]);
                setOrginalTags([]);
            }
        });
        setFollowId(id);
    }

    function change(e) {
        console.log(e);
        setSelectedTags(e);
    }

    function changePage(page, pageSize) {
        setCurrent(page);
    }

    function save() {
        const addLinks = [];
        const delLinks = [];
        if (orginalTags.length === 0) {
            // 全部为新增
            selectedTags.forEach(item => {
                const tagLink = {
                    tagId: item,
                    followInfoId: followId,
                };
                addLinks.push(tagLink);
            });
        } else {
            // 找到交集（无需处理）
            const joinArr = orginalTags.filter(item => selectedTags.indexOf(item.tagId) > -1);
            console.log(joinArr);
            const joinArrWithoutId = joinArr.map(item => item.tagId);
            // 查询交集与新集合的差集（新增）
            const addArr = selectedTags.filter(item => joinArrWithoutId.indexOf(item) === -1);
            console.log(addArr);
            // 查询交集与老集合的差集（删除）
            const delArr = orginalTags.filter(item => joinArrWithoutId.indexOf(item.tagId) === -1);
            console.log(delArr);
            addArr.forEach(item => {
                const tagLink = {
                    tagId: item,
                    followInfoId: followId,
                };
                addLinks.push(tagLink);
            });
            delArr.forEach(item => {
                const tagLink = {
                    tagId: item.tagId,
                    followInfoId: followId,
                    id: item.id,
                };
                delLinks.push(tagLink);
            });
        }
        const map = {
            addLinks: addLinks,
            delLinks: delLinks,
        };
        saveCustomerTagLink(map).then(res => {
            console.log(res);
            setVisible(false);
            reload();
            message.success('标签设置成功');
        });
    }

    function renderTags() {
        return tagGroups.map((tagGroup, idx) => (
            <div key={idx}>
                <p className={styles.title}>{tagGroup.groupName}</p>
                <div className={styles.checkbox}>
                    {tagGroup.tagList.length > 0 &&
                        tagGroup.tagList.map((tag, i) => (
                            <Checkbox value={tag.tagId} key={i}>
                                {tag.tagName}
                            </Checkbox>
                        ))}
                </div>
            </div>
        ));
    }

    return (
        <Modal
            title={'设置标签'}
            width={'70%'}
            onCancel={() => setVisible(false)}
            onOk={save}
            visible={visible}
        >
            <div className={styles.container}>
                <div className={styles.content}>
                    <Checkbox.Group style={{width: '60%'}} onChange={change} value={selectedTags}>
                        {tagGroups.length > 0 && renderTags()}
                    </Checkbox.Group>
                </div>
                <Pagination
                    onChange={changePage}
                    current={current}
                    showTotal={total => `共 ${total} 条记录`}
                    total={total}
                    pageSize={size}
                    style={{float: 'right'}}
                />
            </div>
        </Modal>
    );
});

TagModal.propTypes = {
    reload: PropTypes.func,
};

TagModal.displayName = 'TagModal';

export default TagModal;
